"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Box, Typography } from "@mui/material"
import { Close, Save, Edit } from "@mui/icons-material"
import UserForm from "./UserForm"

const ModalEditarUsuario = ({ open, usuario, handleClose }) => {
  const { updateUsuario } = useContext(ErpContext)

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: "70vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "#f8f9fa",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Edit sx={{ color: "#5b5b5f", fontSize: 28 }} />
          <Typography variant="h5" component="span" sx={{ fontWeight: 600, color: "#5b5b5f" }}>
            Editar Usuario
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={() => handleClose(false)}
          sx={{
            color: "#5b5b5f",
            "&:hover": {
              backgroundColor: "rgba(91, 91, 95, 0.1)",
            },
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 4, px: 4 }}>
        <UserForm
          mode="edit"
          formId="edit-user-form"
          initialValues={usuario || {}}
          onSubmit={async (payload) => {
            await updateUsuario(
              usuario.id,
              payload.usuario,
              payload.nombre,
              payload.apellido,
              payload.telefono,
              payload.email,
              payload.dniCuitCuil,
              payload.direccion,
              payload.localidad,
              payload.provincia,
              payload.password,
              payload.rol,
            )
          }}
          onSuccess={() => {
            handleClose(true)
          }}
          onError={(error) => {
            console.error("Error al actualizar usuario:", error)
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 4,
          py: 3,
          borderTop: 1,
          borderColor: "divider",
          gap: 2,
          bgcolor: "#f8f9fa",
        }}
      >
        <Button
          onClick={() => handleClose(false)}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            borderColor: "#5b5b5f",
            color: "#5b5b5f",
            "&:hover": {
              borderColor: "#5b5b5f",
              backgroundColor: "rgba(91, 91, 95, 0.04)",
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          form="edit-user-form"
          variant="contained"
          startIcon={<Save />}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 4,
            backgroundColor: "#5b5b5f",
            "&:hover": {
              backgroundColor: "#4a4a4e",
            },
          }}
        >
          Actualizar Usuario
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarUsuario
